// extracted by mini-css-extract-plugin
export default {"wrapper":"Jfa-z","message":"Kfa-z","image":"Lfa-z"};